import { z } from "zod";
import { 
  PROOF_TYPE,
  PROOF_FILE,
  OWNERSHIP_PROOF_DOCS,
  STATUS,
  ATTACHMENT_ID,
  IS_REQUIRED,
  FILE_SIZE,
  FILE_TYPE,
  UPLOADED_STATUS,
  PACKET_DOC_ID,
  CLOSING_ACK,
 } from "../../consts";

export const schema = z.object({
  [OWNERSHIP_PROOF_DOCS]: z
    .array(
      z.object({
        [PACKET_DOC_ID]: z.string().optional(),
        [ATTACHMENT_ID]: z.string().optional(),
        [PROOF_TYPE]: z.string().optional(),
        [IS_REQUIRED]: z.boolean().optional(),
        [FILE_SIZE]: z.string().optional(),
        [FILE_TYPE]: z.string().optional(),
        [PROOF_FILE]: z.any().optional(),
        [UPLOADED_STATUS]: z.boolean().optional(),
      })
    ),
  [CLOSING_ACK]: z.boolean().optional(),
  [STATUS]: z.string().optional(),
});


export type formValues = z.infer<typeof schema>;
